import React from "react";
import { IModifyUser } from "ui/Scripts/source/models/user/modifyUser";
import { ModifyUserInfo } from "../ModifyUserInfo";
import { UnlockToolButton } from "../../Button/UnlockToolButton";

export interface ILockedUserInfoProp {
    lockedUser: IModifyUser;
    onUnlockAndLockToMe: () => void;
}

export const LockedUserInfo = (props: ILockedUserInfoProp) => (
    <ModifyUserInfo
        modifyUser={props.lockedUser}
        suffixElement={props.onUnlockAndLockToMe
            ? <UnlockToolButton
                //sx={{ marginLeft: ".5rem", marginTop: "-8px", marginBottom: "-8px" }}
                onClick={props.onUnlockAndLockToMe}
            />
            : null
        }
    />
);
